import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from './ui/button';
import { ArrowRight, Sparkles } from 'lucide-react';

export const FinalCTA = () => {
  const { t } = useTranslation();
  return (
    <section data-testid="final-cta-section" className="py-20 sm:py-28 relative overflow-hidden">
      <div className="absolute inset-0 pointer-events-none" aria-hidden="true">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[700px] h-[700px] rounded-full bg-[hsl(var(--primary))] opacity-[0.1] blur-[150px]" />
        <div className="absolute top-1/2 left-1/3 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] rounded-full bg-[hsl(var(--neon-accent))] opacity-[0.07] blur-[120px]" />
        <div className="absolute inset-0 bg-grid opacity-15" />
      </div>
      <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8 text-center relative z-10">
        <div className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-[hsl(var(--surface)/0.8)] border border-[hsl(var(--primary-glow)/0.5)] mb-6 shadow-[0_0_20px_hsl(var(--primary)/0.2)] backdrop-blur-md">
          <Sparkles className="w-4 h-4 text-[hsl(var(--primary-glow))] drop-shadow-[0_0_6px_hsl(var(--primary-glow))]" />
          <span className="text-sm text-[hsl(var(--primary-glow))] font-semibold">{t('cta.badge')}</span>
        </div>
        <h2 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight mb-5">
          <span className="text-gradient-hero drop-shadow-[0_0_20px_hsl(var(--primary-glow)/0.4)]">{t('cta.title_line1')}</span>
          <br />
          <span className="text-gradient text-neon drop-shadow-[0_0_30px_hsl(var(--primary-glow)/0.6)]">{t('cta.title_line2')}</span>
        </h2>
        <p className="text-base sm:text-lg text-white/75 max-w-xl mx-auto mb-8">{t('cta.subtitle')}</p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Button data-testid="final-cta-button" size="lg" className="btn-neon text-base px-10 h-13 gap-2 group animate-glow-pulse shadow-[0_0_30px_hsl(var(--primary)/0.5)] font-semibold">
            {t('cta.primary')}
            <ArrowRight className="w-4 h-4 transition-transform duration-200 group-hover:translate-x-1" />
          </Button>
          <Button variant="outline" size="lg" className="border-[hsl(var(--border))] hover:bg-[hsl(var(--surface))] hover:border-[hsl(var(--primary-glow)/0.5)] hover:shadow-[0_0_20px_hsl(var(--primary)/0.2)] text-base px-8 h-13 transition-all duration-300 text-white/80 font-semibold">
            {t('cta.secondary')}
          </Button>
        </div>
        <p className="mt-6 text-xs text-white/55">{t('cta.footer')}</p>
      </div>
    </section>
  );
};

export default FinalCTA;
